import { FormObjType } from "DataTypes/Form";

export const FormDataArr: FormObjType[] = [
  {
    id: "practice",
    label: "Organization Name",
    placeholder: "Select Organization",
    boxType: "input",
    boxSize: 6,
    validatetype: "org-name",
    readOnly: true,
    required: true,
    enableFormLoad: true,
  },
  {
    id: "location",
    label: "Location Name",
    placeholder: "Select Location",
    boxType: "single-select",
    dropArr: [],
    boxSize: 6,
    validatetype: "dropdown",
    required: true,
    enableFormLoad: true,
  },
];

export type SectionType =
  | "demographic"
  | "insurances"
  | "emergency-contacts"
  | "medications"
  | "problems"
  | "allergies"
  | "vitals"
  | "results"
  | "vaccines"

export const SectionsList: { id: SectionType, label: string }[] = [
  {
    id: "demographic",
    label: "Profile Section",
  },
  {
    id: "insurances",
    label: "Insurance"
  },
  {
    id: "emergency-contacts",
    label: "Emergency Contacts"
  },
  {
    id: "medications",
    label: "Medications"
  },
  {
    id: "problems",
    label: "Problems"
  },
  {
    id: "allergies",
    label: "Allergies"
  },
  // {
  //   id: "vitals",
  //   label: "Vitals"
  // },
  {
    id: "vaccines",
    label: "Vaccines"
  },
  // {
  //   id: "results",
  //   label: "Results"
  // },
]